import React, { Component } from 'react'
import { Link, graphql } from 'gatsby'
import PropTypes from 'prop-types'

import Layout from '../components/Layout'
import PrimaryHeroV3 from '../components/Heros/PrimaryHeroV3'

class AvantPrivacyNoticeV3 extends Component {
  // setting a reference to the main content for drop in header
  dropInHeader = React.createRef()

  render() {
    const { contentfulNavbar, contentfulFooter, contentfulSeoMetadata } = this.props.data
    const revisionDate = contentfulSeoMetadata.avantPrivacyNoticeRevisionDate

    return (
      <Layout
        dropInHeader={this.dropInHeader}
        hasFullLegal
        footerData={contentfulFooter}
        metaData="privacyNotices"
        pageCategory="legal"
        v3Styles
        navigation={contentfulNavbar}
      >
        <PrimaryHeroV3 title="AVANT PRIVACY NOTICE" legal />

        <main ref={this.dropInHeader} id="maincontent" className="privacy-notice">
          <div className="legal container__inner">
            <h2
              className="legal__heading"
              style={{ whiteSpace: 'nowrap', maxWidth: 'unset', minWidth: '100%' }}
            >
              ONLINE PRIVACY NOTICE<span style={{ float: 'right' }}>Rev. {revisionDate}</span>
            </h2>
            <table className="privacy-notice__table" border="1">
              <tbody>
                <tr className="privacy-notice__header-row">
                  <th scope="col" className="privacy-notice__header" type="two-col-sm">
                    FACTS
                  </th>
                  <th
                    scope="col"
                    className="privacy-notice__header privacy-notice__header"
                    type="two-col-lg"
                  >
                    WHAT DOES AVANT, LLC (&#34;AVANT&#34;) DO WITH YOUR PERSONAL INFORMATION?
                  </th>
                </tr>

                <tr type="gap" />

                <tr className="privacy-notice__row">
                  <th scope="row" className="privacy-notice__data" type="two-col-sm">
                    Why?
                  </th>
                  <td className="privacy-notice__data">
                    Financial companies choose how they share your personal information. Federal law
                    gives consumers the right to limit some but not all sharing. Federal law also
                    requires us to tell you how we collect, share, and protect your personal
                    information. Please read this notice carefully to understand what we do
                  </td>
                </tr>

                <tr type="gap" />

                <tr className="privacy-notice__row">
                  <th scope="row" className="privacy-notice__data" type="two-col-sm">
                    What?
                  </th>
                  <td className="privacy-notice__data">
                    <p className="privacy-notice__text">
                      The types of personal information we collect and share depend on the product
                      or service you have or access through us. This information can include:
                    </p>
                    <ul className="privacy-notice__list">
                      <li>Social Security number and income</li>
                      <li>Account balances and transaction history</li>
                      <li>Credit history and assets</li>
                    </ul>
                  </td>
                </tr>

                <tr type="gap" />

                <tr className="privacy-notice__row">
                  <th scope="row" className="privacy-notice__data" type="two-col-sm">
                    How?
                  </th>
                  <td className="privacy-notice__data">
                    All financial companies need to share customers’ personal information to run
                    their everyday business. In the section below, we list the reasons financial
                    companies can share their customers’ personal information; the reasons Avant
                    choose to share; and whether you can limit this sharing.
                  </td>
                </tr>

                <tr type="gap" />
              </tbody>
            </table>

            <table className="privacy-notice__table" border="1">
              <tbody>
                <tr>
                  <th scope="col" className="privacy-notice__header" type="three-col-lg">
                    Reasons we can share your personal information
                  </th>
                  <th scope="col" className="privacy-notice__header" type="three-col-sm">
                    Does Avant share?
                  </th>
                  <th scope="col" className="privacy-notice__header" type="three-col-sm">
                    Can you limit this sharing?
                  </th>
                </tr>

                <tr className="privacy-notice__row">
                  <td className="privacy-notice__data">
                    <strong>For our everyday business purposes—</strong>
                    <br /> such as to process your transactions, maintain your account(s), respond
                    to court orders and legal investigations, or report to credit bureaus
                  </td>

                  <td className="privacy-notice__data">Yes</td>
                  <td className="privacy-notice__data">No</td>
                </tr>

                <tr className="privacy-notice__row">
                  <td className="privacy-notice__data">
                    <strong>For our marketing purposes—</strong>
                    <br /> to offer our products and services to you
                  </td>

                  <td className="privacy-notice__data">Yes</td>
                  <td className="privacy-notice__data">No</td>
                </tr>

                <tr className="privacy-notice__row">
                  <td className="privacy-notice__data">
                    <strong>For joint marketing with other financial companies</strong>
                  </td>

                  <td className="privacy-notice__data">Yes</td>
                  <td className="privacy-notice__data">No</td>
                </tr>

                <tr className="privacy-notice__row">
                  <td className="privacy-notice__data">
                    <strong>For our affiliates’ everyday business purposes—</strong>
                    information about your transactions and experiences
                  </td>

                  <td className="privacy-notice__data">Yes</td>
                  <td className="privacy-notice__data">No</td>
                </tr>

                <tr className="privacy-notice__row">
                  <td className="privacy-notice__data">
                    <strong>For our affiliates’ everyday business purposes—</strong>
                    information about your creditworthiness
                  </td>

                  <td className="privacy-notice__data">Yes</td>
                  <td className="privacy-notice__data">Yes</td>
                </tr>

                <tr className="privacy-notice__row">
                  <td className="privacy-notice__data">
                    <strong>For our affiliates to market to you</strong>
                  </td>

                  <td className="privacy-notice__data">Yes</td>
                  <td className="privacy-notice__data">Yes</td>
                </tr>

                <tr className="privacy-notice__row">
                  <td className="privacy-notice__data">
                    <strong>For nonaffiliates to market to you</strong>
                  </td>

                  <td className="privacy-notice__data">Yes</td>
                  <td className="privacy-notice__data">Yes</td>
                </tr>

                <tr type="gap" />
              </tbody>
            </table>

            <table className="privacy-notice__table" border="1">
              <tbody>
                <tr className="privacy-notice__row">
                  <th scope="row" className="privacy-notice__data" type="two-col-sm">
                    To limit our sharing
                  </th>

                  <td className="privacy-notice__data" width="71%">
                    <p className="privacy-notice__text">
                      Call <a href="tel:800-712-5407">800-712-5407</a>
                    </p>

                    <p className="privacy-notice__text">
                      <strong>Please note</strong>
                    </p>

                    <p className="privacy-notice__text">
                      If you are a new customer, for the reasons we can share your information and
                      for which you can limit the sharing, we can begin sharing your information 30
                      days from the date we sent this notice. When you are no longer our customer,
                      we continue to share your information as described in this notice.
                    </p>

                    <p>However, you can contact us at any time to limit our sharing.</p>
                  </td>
                </tr>
                <tr type="gap" />
              </tbody>
            </table>

            <table className="privacy-notice__table" border="1">
              <tbody>
                <tr className="privacy-notice__row">
                  <th scope="row" className="privacy-notice__data" type="two-col-sm">
                    Questions?
                  </th>

                  <td className="privacy-notice__data" width="71%">
                    Call <a href="tel:800-712-5407">800 712-5407</a> or go to{' '}
                    <Link to="/">www.avant.com</Link>
                  </td>
                </tr>

                <tr type="gap" />
              </tbody>
            </table>

            <table className="privacy-notice__table" border="1">
              <tbody>
                <tr>
                  <th
                    scope="col"
                    className="privacy-notice__header"
                    type="three-col-lg"
                    colSpan="2"
                  >
                    What we do
                  </th>
                </tr>

                <tr className="privacy-notice__row">
                  <th scope="row" className="privacy-notice__data">
                    <strong>How does Avant protect my personal information?</strong>
                  </th>

                  <td className="privacy-notice__data" type="two-col-lg">
                    <p className="privacy-notice__text">
                      To protect your personal information from unauthorized access and use, we use
                      security measures that comply with federal law. These measures include
                      computer safeguards and secured files and buildings.
                    </p>

                    <p className="privacy-notice__text">
                      We restrict access to your information to those employees who need to know it
                      to provide products or services to you
                    </p>
                  </td>
                </tr>

                <tr className="privacy-notice__row">
                  <th scope="row" className="privacy-notice__data">
                    <strong>How does Avant collect my personal information?</strong>
                  </th>

                  <td className="privacy-notice__data" type="two-col-lg">
                    <p className="privacy-notice__text">
                      We collect your personal information, for example, when you
                    </p>

                    <ul className="privacy-notice__list">
                      <li>apply for a loan</li>
                      <li>use your credit or debit card</li>
                      <li>tell us where to send the money</li>
                      <li>provide employment information</li>
                      <li>show your government-issued ID</li>
                    </ul>

                    <p className="privacy-notice__text-btm">
                      We also collect your personal information from others, such as credit bureaus,
                      affiliates, or other companies.
                    </p>
                  </td>
                </tr>

                <tr className="privacy-notice__row">
                  <th scope="row" className="privacy-notice__data">
                    <strong>Why can’t I limit all sharing?</strong>
                  </th>

                  <td className="privacy-notice__data" type="two-col-lg">
                    <p className="privacy-notice__text">
                      Federal law gives you the right to limit only
                    </p>

                    <ul className="privacy-notice__list">
                      <li>
                        sharing for affiliates’ everyday business purposes—information about your
                        creditworthiness
                      </li>
                      <li>affiliates from using your information to market to you</li>
                      <li>sharing for nonaffiliates to market to you</li>
                    </ul>

                    <p className="privacy-notice__text-btm">
                      State laws and individual companies may give you additional rights to limit
                      sharing. See below for more on your rights under state law.
                    </p>
                  </td>
                </tr>

                <tr type="gap" />
              </tbody>
            </table>

            <table className="privacy-notice__table" border="1">
              <tbody>
                <tr>
                  <th
                    scope="col"
                    className="privacy-notice__header"
                    type="three-col-lg"
                    colSpan="2"
                  >
                    Definitions
                  </th>
                </tr>

                <tr className="privacy-notice__row">
                  <th scope="row" className="privacy-notice__data">
                    <strong>Affiliates</strong>
                  </th>

                  <td className="privacy-notice__data" type="two-col-lg">
                    <p className="privacy-notice__text">
                      Companies related by common ownership or control. They can be financial and
                      nonfinancial companies.
                    </p>

                    <ul className="privacy-notice__list">
                      <li>
                        <em>
                          Our affiliates include financial companies such as Zero Financial, Inc.,
                          Avant of California LLC, Avant of Idaho, LLC, Avant of Wisconsin, LLC,
                          Avant of Illinois, etc.
                        </em>
                      </li>
                    </ul>
                  </td>
                </tr>

                <tr className="privacy-notice__row">
                  <th scope="row" className="privacy-notice__data">
                    <strong>Nonaffiliates</strong>
                  </th>

                  <td className="privacy-notice__data" type="two-col-lg">
                    <p className="privacy-notice__text">
                      Companies not related by common ownership or control. They can be financial
                      and nonfinancial companies.
                    </p>

                    <ul className="privacy-notice__list">
                      <li>
                        <em>
                          Nonaffiliates we share with may include financial service providers,
                          non-financial companies, and other businesses
                        </em>
                      </li>
                    </ul>
                  </td>
                </tr>

                <tr className="privacy-notice__row">
                  <th scope="row" className="privacy-notice__data">
                    <strong>Joint marketing</strong>
                  </th>

                  <td className="privacy-notice__data" type="two-col-lg">
                    <p className="privacy-notice__text">
                      A formal agreement between nonaffiliated financial companies that together
                      market financial products or services to you.
                    </p>

                    <ul className="privacy-notice__list">
                      <li>
                        <em>
                          Our joint marketing partners include financial service providers, and
                          other businesses
                        </em>
                      </li>
                    </ul>
                  </td>
                </tr>
                <tr type="gap" />
              </tbody>
            </table>

            <table className="privacy-notice__table" border="1">
              <tbody>
                <tr>
                  <th
                    scope="col"
                    className="privacy-notice__header"
                    type="three-col-lg"
                    colSpan="2"
                  >
                    Other important information
                  </th>
                </tr>

                <tr className="privacy-notice__row">
                  <td className="privacy-notice__data" type="two-col-lg">
                    <p className="privacy-notice__text">
                      <strong>Notice to California Residents.</strong>
                    </p>

                    <p className="privacy-notice__text">
                      Under California law, we will not share information we collect about you with
                      companies outside of Avant, unless the law allows. For example, we may share
                      information with your consent or to service your account. We will limit
                      sharing to the extent required by California law.
                    </p>

                    <p className="privacy-notice__text">
                      <strong>Notice to Nevada Residents.</strong>
                    </p>

                    <p className="privacy-notice__text">
                      We are providing you this notice pursuant to Nevada law. You may be placed on
                      our internal Do Not Call List by calling 1–800-712-5407 or by writing to us at
                      222 W Merchandise Mart Plaza, Suite 900, Chicago, IL 60654. For more
                      information, contact us at the address above, or email support@avant.com. You
                      may also contact the Nevada Attorney General&#39;s office: Bureau of Consumer
                      Protection, Office of the Nevada Attorney General, 555 E. Washington St.,
                      Suite 3900, Las Vegas, NV 89101; telephone number: 1–702–486–3132; email
                      BCPINFO@ag.state.nv.us.
                    </p>

                    <p className="privacy-notice__text">
                      <strong>Notice to Texas Residents</strong>
                    </p>

                    <p className="privacy-notice__text">
                      Avant of Texas, LLC is licensed and examined under the laws of the State of
                      Texas and by state law is subject to regulatory oversight by the Office of
                      Consumer Credit Commissioner. Any consumer wishing to file a complaint against
                      Avant of Texas, LLC should contact the Office of Consumer Credit Commissioner
                      through one of the means indicated below: In Person or U.S. Mail: 2601 North
                      Lamar Boulevard, Austin, Texas 78705-4207. Telephone No.: (800) 538-1579. Fax
                      No.: (512) 936-7610. E-mail: consumer.complaints@occc.state.tx.us. Website:{' '}
                      <a target="_blank" rel="noopener noreferrer" href="https://occc.texas.gov/">
                        www.occc.state.gov
                      </a>
                      .
                    </p>

                    <p className="privacy-notice__text">
                      <strong>Notice to Vermont Residents</strong>
                    </p>

                    <ul className="privacy-notice__list">
                      <li>
                        We will not disclose information about your creditworthiness to our
                        affiliates and will not disclose your personal information, financial
                        information, credit report, or health information to nonaffiliated third
                        parties to market to you, other than as permitted by Vermont law, unless you
                        authorize us to make those disclosures.
                      </li>

                      <li>
                        Additional information concerning our privacy policies can be found at{' '}
                        <Link to="/">www.avant.com</Link> or call{' '}
                        <a href="tel:800-712-5407">800 712-5407</a>.
                      </li>
                    </ul>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </main>
      </Layout>
    )
  }
}

AvantPrivacyNoticeV3.propTypes = {
  data: PropTypes.object.isRequired
}

export const query = graphql`
  query {
    contentfulFooter(contentful_id: { eq: "20vfAUjNRIwf2ynidZXDPx" }) {
      logo {
        url
        image {
          title
          file {
            url
          }
        }
      }
      linkGroups {
        title
        links {
          ... on ContentfulTextLink {
            title
            url
            payload {
              internal {
                content
              }
            }
          }
        }
      }
      copyright
      socialIcons {
        url
        image {
          title
          file {
            url
          }
        }
      }
    }

    contentfulNavbar(contentful_id: { eq: "5buYQYZM9HoflvY5Yx5QbI" }) {
      id
      blogCategoryNavigation {
        id
      }
      linkGroups {
        ... on ContentfulAvantComFooterNavList {
          title
          url
          links {
            title
            url
          }
          internal {
            type
          }
        }
        ... on ContentfulTextLink {
          title
          url
          internal {
            type
          }
        }
      }
      loginButton {
        dataEvent
        title
        url
        internal {
          type
        }
      }
      logo {
        image {
          file {
            url
          }
        }
        imageAltText
        url
      }
      mobileLogo {
        image {
          file {
            url
          }
        }
        imageAltText
        url
      }
      myAccount {
        links {
          title
          url
          dataEvent
        }
        title
        internal {
          type
        }
      }
      redeemOfferLinkGroup {
        title
        links {
          title
          url
        }
        internal {
          type
        }
      }
    }
    contentfulSeoMetadata(contentful_id: { eq: "KC2Syrm16SuPLMffleSVl" }) {
      avantPrivacyNoticeRevisionDate(formatString: "MM/YYYY")
    }
  }
`

export default AvantPrivacyNoticeV3
